<template>
  <v-card
    fill-height
    fluid
  >
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >

      <v-tab
        v-for="item in tabs"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
        :key="item.tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in tabs"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
        :key="item.tab"
      >
        <component :is="item.componentName" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

export default {
  components: {
    BulkCreateAccounts: () => import('@/modules/bulk-create-accounts').then(module => module.BulkCreateAccountsContainer),
    BulkPaymethodWhitelist: () => import('@/modules/bulk-paymethod-whitelist').then(module => module.BulkPaymethodWhitelistContainer),
    FundTestAccounts: () => import('@/modules/fund-test-accounts').then(module => module.FundTestAccountsContainer),
    ExportDataReupload: () => import('@/modules/export-data-reupload').then(module => module.ExportDataReuploadContainer),
    LaunchGame: () => import('@/modules/launch-game').then(module => module.LaunchGameContainer),
    CiPipelines: () => import('@/modules/ci-pipelines').then(module => module.CiPipelinesContainer),
    BulkEditGames: () => import('@/modules/bulk-edit-games').then(module => module.BulkEditGamesContainer),
    CommunicationBots: () => import('@/modules/communication-bots').then(module => module.CommunicationBotsContainer),
    BulkEditAccounts: () => import('@/modules/bulk-edit-accounts').then(module => module.BulkEditAccountsContainer),
  },

  data() {
    return {
      tabs: [
        { tab: 'Bulk Create Accounts', componentName: 'bulk-create-accounts', access: 'bulk_account_create', },
        { tab: 'Bulk Paymethod Whitelist', componentName: 'bulk-paymethod-whitelist', access: 'bulk_account_update', },
        { tab: 'Fund Test Accounts', componentName: 'fund-test-accounts', access: 'fund_test_accounts', },
        { tab: 'Export Data Reupload', componentName: 'export-data-reupload', access: 'export_data_reupload', },
        { tab: 'Game Launch', componentName: 'launch-game', access: 'game_launch', },
        { tab: 'CI Pipelines', componentName: 'ci-pipelines', access: 'gitlab_ci', },
        { tab: 'Bulk Game Update', componentName: 'bulk-edit-games', access: 'bulk_game_update', },
        { tab: 'Communication Bot Triggers', componentName: 'communication-bots', access: 'communication_bots', },
        { tab: 'Bulk Edit Accounts', componentName: 'bulk-edit-accounts', access: 'bulk_account_update', },
      ],
      tab: null,
    }
  },
}

</script>
